module.exports = __webpack_public_path__ + "img/facility5.e334d528.png";